module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwBAMAAAClLOS0AAAAD1BMVEUAAABKSkpJSUlISEhJSUk5jWJCAAAABHRSTlMAgL9ARyeO/QAAAPhJREFUOMuNklESgjAMRAU9QFUOgEMPUGc4AC25/5kUKLwmwGi+wi7JNsletrg+fHqF7RPcyxRuRyy4RIv3kmM0jb5Qet6nMi1zy00akRZ0BlJYkxKvtufUuRcEYq2SiDQdlMTAP2NJUF9LVGM75NIxcTVEOK2AiP+I98VzFVGfDVixIY7IhthaqR7z5c1xaw7lQDOS7m8vjIf8Eu4nAQ5jbZg8DNLShcm/qxlp9CR1pW87fqKE3MzYsEK1lUrYNGYk0atms+qeI6fRvRLXM72C9gtztcbFmAZbaJFxJtyeiNhTqycMvScwUvneQyJj3o6xYlVn0AX7AAM3RAAqj6OzAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/icon_user.png
// module id = 1UOV
// module chunks = 31